import { useSiteWideMessaging } from '../../../app/_providers/SiteWideMessagingProvider.client'

export function useViewModel() {
  const { siteWideEmbroideryDisclosure, siteWideCartLogoDigitizationWarning } =
    useSiteWideMessaging()

  return {
    siteWideEmbroideryDisclosure,
    siteWideCartLogoDigitizationWarning,
  }
}
